import { Logger } from './../../logger/Logger';
import { CollectionParametersObject } from './../../autogenerated/ZoomBridge';
import ErrorId from './../../protocol/ErrorId';
import CollectionUtil from './CollectionUtil';

export default class LinkSharingProperties {
  /**
   * 
   * @param {CollectionParametersObject} collectionParametersObject 
   * @param {string} privateLinkId
   */
  constructor(collectionParametersObject, privateLinkId) {
    /**
     * @type {CollectionParametersObject}
     * @private
     */
    this.collectionParametersObject = collectionParametersObject;
    if (this.collectionParametersObject) {
      this.collectionParams = this.collectionParametersObject.getCollectionParams();
    }
    this.privateLinkId = privateLinkId;
    /**
     * @type {boolean}
     */
    this.loginRequired = this.collectionParams ? CollectionUtil.isLoginRequiredForLink(this.collectionParams) : false;
    /**
     * @type {boolean}
     */
    this.linkSharingInviteOnly = this.collectionParams ? CollectionUtil.isLinkSharingInviteOnly(this.collectionParams) : false;
    /**
     * @type {boolean}
     */
    this.linkSharingDisabled = this.collectionParams ? CollectionUtil.isLinkSharingDisabled(this.collectionParams) : false;
    /**
     * @type {boolean}
     */
    this.commentWithLink = this.collectionParams ? CollectionUtil.canCommentWithLink(this.collectionParams) : false;
    /**
     * @type {boolean}
     */
    this.readOnLink = this.collectionParams ? CollectionUtil.isReadOnlyLink(this.collectionParams) : null;
  }

  isLoginRequired() {
    return this.loginRequired;
  }

  isLinkSharingInviteOnly() {
    return this.linkSharingInviteOnly;
  }

  isLinkSharingDisabled() {
    return this.linkSharingDisabled;
  }

  canCommentWithLink() {
    return this.commentWithLink;
  }

  isReadOnlyLink() {
    return this.readOnLink;
  }

  getCollectionId() {
    return this.collectionParametersObject.getCollectionId();
  }

  getPrivateLinkId() {
    return this.privateLinkId;
  }

}